const SMS_NOT_SENT_REASONS: Record<string, string> = {
  no_phone: "No phone number on file for this lead",
  no_valid_phone: "No valid phone number on file — sent by email instead",
  opted_out: "The lead opted out of text messages",
  no_sender_number:
    "No texting number is set up for this account yet — nothing was sent",
  provider_failure: "Our messaging service rejected it — nothing was sent",
  send_error: "Sending failed — nothing was sent",
  landline: "This number can't receive text messages (landline)",
  invalid_number: "This phone number appears to be invalid",
  carrier_blocked: "The carrier blocked this message"
};

const humanizeReason = (reason: string) =>
  reason.replace(/_/g, " ").replace(/^./, (char) => char.toUpperCase());

export const describeSmsNotSentReason = (reason?: string | null): string =>
  reason
    ? (SMS_NOT_SENT_REASONS[reason] ?? humanizeReason(reason))
    : "This text wasn't sent";
